import { Typography } from '@mui/material'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRegrasCalculoContext } from 'pages/RegrasCalculo'
import { useParams } from 'react-router-dom'
import { regrasCalculo } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRegraCalculoPage() {
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useSoftDelete({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Regra de cálculo excluída com sucesso')
        },
        onError: () => {
            toast.error('Erro ao excluir regra de cálculo')
        },
    })

    const { regrasCalculoId } = useParams()
    const { data } = useRegrasCalculoContext()

    const row = data?.find(item => item.id === +regrasCalculoId!)
    if (!row) return null

    return (
        <Dialog.Root
            open={hasPermission(['delete', 'RegrasDeCálculo'])}
            defaultValues={row}
            loading={isLoading}
            onSubmit={values => mutateAsync(values)}
            height="auto"
        >
            <Dialog.Title>Excluir regra de cálculo</Dialog.Title>
            <Dialog.Content>
                <Typography>
                    Deseja realmente excluir esta regra de cálculo?
                </Typography>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
